// The Light Room Home : interrupteur des Bestsellers, toutes les lampes s'allument d'un coup.
(() => {
  // point lumineux par produit, en % de la photo carrée (défaut : centre, 45 %)
  const LIGHT = {"pleated-fabric-petal-chandelier-serenna":[50,72],"modern-chandelier-lighting-korina":[50,65],
    "adjustable-brass-floor-lamp-lunora":[54,13],"travertine-wood-led-ceiling-light-monane":[50,52],
    "travertin-half-moon-wall-light-talira":[50,35],"modern-mushroom-rechargeable-table-lamp":[48,44],
    "pebble-flush-mount-ceiling-light-torera":[52,48],"large-led-floor-lamp-morane":[49,25]};
  function setup(sec){
    if (!sec || sec.dataset.tlr) return; sec.dataset.tlr = 1;
    sec.classList.add('tlr-lightup');
    sec.querySelectorAll('product-card,.product-card').forEach(card => {
      const g = card.querySelector('.card-gallery'); if (!g || g.querySelector('.tlr-lg')) return;
      const a = card.querySelector('a[href*="/products/"]'), h = a ? a.getAttribute('href').split('/products/')[1].split(/[?#/]/)[0] : '';
      const p = LIGHT[h]; const s = document.createElement('span'); s.className = 'tlr-lg';
      if (p) { s.style.setProperty('--px', p[0] + '%'); s.style.setProperty('--py', p[1] + '%'); }
      g.appendChild(s);
    });
    const b = document.createElement('button');
    b.type = 'button'; b.className = 'tlr-sw'; b.setAttribute('role', 'switch'); b.setAttribute('aria-checked', 'false');
    b.innerHTML = '<span class="tr"><i></i></span><span class="sl">Turn the lights on</span>';
    b.onclick = () => { const on = !sec.classList.contains('on'); sec.classList.toggle('on', on);
      b.setAttribute('aria-checked', on); b.querySelector('.sl').textContent = on ? 'Lights on' : 'Turn the lights on'; };
    // à côté du lien « View all » de l'en-tête de la section, sinon en tête de section
    const link = sec.querySelector('a[href*="/collections/"]:not(.product-card__link)');
    if (link && link.parentElement) { link.parentElement.style.display = 'flex'; link.parentElement.style.alignItems = 'center';
      link.parentElement.style.gap = '22px'; link.parentElement.style.flexWrap = 'wrap'; link.parentElement.insertBefore(b, link); }
    else sec.querySelector('.section, div')?.prepend(b);
  }
  const run = () => setup(document.querySelector('[id$="__bestsellers"]'));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();
